module.exports = __webpack_public_path__ + "assets/src/style/img/footer-leeuwarden.png?977ee015e1b35a9030aa5c40f46eb478";